import { BasicCartesianChartConfig } from '@app/data/interface/widget-config';
import {
  BasicCartesianChartEchartConfigTemplate,
  BasicCartesianChartAxisTemplate,
} from '@app/data/widget-config-templates/basic-cartesian-chart';
export const WhakaaweWhenuaHeiBridge: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#8c7ebb', '#66c39b', '#007093'],
    grid: {
      top: '25%',
      left: '10%',
      right: '10%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Total\nPhosphorus\ng/m³',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#8c7ebb',
          },
        },
        axisLabel: {
          color: '#8c7ebb',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Total\nNitrogen\ng/m³',
        offset: 60,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#66c39b',
          },
        },
        axisLabel: {
          color: '#66c39b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Water Temp\n°C',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#007093',
          },
        },
        axisLabel: {
          color: '#007093',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Total Phosphorus',
        symbolSize: 13,
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Total Nitrogen',
        symbolSize: 13,
      },
      {
        type: 'line',
        yAxisIndex: 2,
        name: 'Water Temp',
        symbolSize: 13,
      },
    ],
  },
  dataConfig: {
    title: 'WHAKAAWE WHENUA - Land Use Impact: Hei bridge',
    widgetId: 1,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'boprc_maketu_estuary_at_boat_ramp',
        analyteIdentifier: 'total-phosphorus',
        valueField: 'avg',
        label: 'Total Phosphorus',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_maketu_estuary_at_boat_ramp',
        analyteIdentifier: 'total-kjeldahl-nitrogen',
        valueField: 'avg',
        label: 'Total Nitogen',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_maketu_estuary_at_boat_ramp',
        analyteIdentifier: 'water-temperature',
        valueField: 'avg',
        label: 'Water Temp',
      },
    ],
  },
};
export const PanoniHeiBridge: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#00b1d8 ', '#ee4891', '#007093'],
    grid: {
      top: '25%',
      left: '10%',
      right: '10%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'DO\nmg/m3',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#00b198',
          },
        },
        axisLabel: {
          color: '#00b198',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Turbidity\nNTU',
        position: 'right',
        offset: 40,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#ee4891',
          },
        },
        axisLabel: {
          color: '#ee4891',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Temp\n°C',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#007093',
          },
        },
        axisLabel: {
          color: '#007093',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Dissolved oxygen',
        symbolSize: 13,
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'Turbidity',
        symbolSize: 13,
      },
      {
        type: 'line',
        yAxisIndex: 2,
        name: 'Water Temp',
        symbolSize: 13,
      },
    ],
  },
  dataConfig: {
    title: 'PANONI - Land Use Change Over Time: Hei bridge',
    widgetId: 1,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'boprc_maketu_estuary_at_boat_ramp',
        analyteIdentifier: 'dissolved-oxygen-mg-per-litre',
        valueField: 'avg',
        label: 'Disolved Oxygen (mg/m3)',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_maketu_estuary_at_boat_ramp',
        analyteIdentifier: 'turbidity',
        valueField: 'avg',
        label: 'Turbidity',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_maketu_estuary_at_boat_ramp',
        analyteIdentifier: 'water-temperature',
        valueField: 'avg',
        label: 'Water Temp',
      },
    ],
  },
};

export const WaiFieldWaterSampling: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#007093', '#f26b4b', '#00b1d8', '#26312b', '#00b1d8'],
    grid: {
      top: '30%',
      left: '15%',
      right: '7%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Temp\n°C',
        offset: 40,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#007093',
          },
        },
        axisLabel: {
          color: '#007093',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'ph in\nLab',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#f26b4b',
          },
        },
        axisLabel: {
          color: '#f26b4b',
        },
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Turbidity\nNTU',
        position: 'right',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#f26b4b',
          },
        },
        axisLabel: {
          color: '#f26b4b',
        },
      },
      {
        name: 'Black \nDisk\ncm',
        offset: 80,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#26312b',
          },
        },
        axisLabel: {
          color: '#26312b',
          formatter: (value: any) => Math.round(parseFloat(value)).toString(),
        },
        type: 'value',
        position: 'left',
        boundaryGap: [0, '100%'],
        alignTicks: true,
      },
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'DO\nmg/m3',
        position: 'right',
        offset: 40,
        axisLine: {
          show: true,
          lineStyle: {
            color: '#00b1d8',
          },
        },
        axisLabel: {
          color: '#00b1d8',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Water Temp',
      },
      {
        type: 'line',
        yAxisIndex: 1,
        name: 'ph in Lab',
      },
      {
        type: 'line',
        yAxisIndex: 2,
        name: 'Turbidity',
      },
      {
        type: 'line',
        yAxisIndex: 3,
        name: 'Black Disk',
      },
      {
        type: 'line',
        yAxisIndex: 4,
        name: 'Dissolved oxygen',
      },
    ],
  },
  dataConfig: {
    title: 'WAI - Field Water Sampling: Hei bridge',
    widgetId: 1,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'boprc_maketu_estuary_at_boat_ramp',
        analyteIdentifier: 'water-temperature',
        valueField: 'avg',
        label: 'Water Temp',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_maketu_estuary_at_boat_ramp',
        analyteIdentifier: 'ph-in-lab',
        valueField: 'avg',
        label: 'PH in Lab',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_maketu_estuary_at_boat_ramp',
        analyteIdentifier: 'turbidity',
        valueField: 'avg',
        label: 'Turbidity',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_maketu_estuary_at_boat_ramp',
        analyteIdentifier: 'setchi-disk',
        valueField: 'avg',
        label: 'Black Disk',
      },
      {
        environmentalDataSourceIdentifier: 'boprc_maketu_estuary_at_boat_ramp',
        analyteIdentifier: 'dissolved-oxygen-mg-per-litre',
        valueField: 'avg',
        label: 'Dissolved Oxygen',
      },
    ],
  },
};

export const WaiRaparapa: BasicCartesianChartConfig = {
  echartsConfig: {
    ...BasicCartesianChartEchartConfigTemplate,
    color: ['#66c39b'],
    grid: {
      top: '25%',
      left: '7%',
      right: '7%',
      bottom: '6%',
      containLabel: true,
    },
    yAxis: [
      {
        ...BasicCartesianChartAxisTemplate,
        name: 'Relative Water Level\nm',
        axisLine: {
          show: true,
          lineStyle: {
            color: '#66c39b',
          },
        },
        axisLabel: {
          color: '#66c39b',
        },
      },
    ],
    series: [
      {
        type: 'line',
        yAxisIndex: 0,
        name: 'Relative Water Level',
      },
    ],
  },
  dataConfig: {
    title: 'WAI - Field Water Sampling : Raparapa-a-Hoe',
    widgetId: 10,
    domain: 'wai',
    dataSources: [
      {
        environmentalDataSourceIdentifier: 'boprc_raparapahoe_at_above_drop_structure',
        analyteIdentifier: 'relative-water-level',
        valueField: 'avg',
        label: 'Relative Water Level',
      },
    ],
  },
};
